module.exports = __webpack_public_path__ + "static/media/splash.59202d46.png";